import { Injectable } from '@angular/core';
import { FccModel } from './../../../api/models/fcc-model';
import { map, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { FCCsMaintenanceService } from '../../../api/services/fccs-maintenance.service';


@Injectable()
export class FccManagementService {
  public static currentData: any;

  constructor(private fccsMaintenanceService: FCCsMaintenanceService) {

  }

  createFcc() {
    return this.fccsMaintenanceService.Create().pipe(map((result) => {
      result.model.fccKey = null;

      return result;
    }));
  }

  getFccs(filter: any) {
    let params: FCCsMaintenanceService.QueryParams = {
      Page: filter.Page,
      PageSize: filter.rows,
      FCCName: filter.fccName,
      StateKey: filter.stateKey,
      IncludeInactive: filter.includeInactive
    };

    return this.fccsMaintenanceService.Query(params).pipe(map((result) => {
      return result;
    }));
  }

  updateFcc(fcc: FccModel): Observable<FccModel> {
    return this.fccsMaintenanceService.Save(fcc).pipe(map((res) => {
      return res.model;
    }));
  }
}
